import * as React from 'react';
import DOMPurify from 'dompurify';
import { templateReplace } from '../helpers';

// Admin-authored template strings may contain basic HTML (e.g. <b>, <br>).
// Row data values are interpolated in via {{field}} placeholders and must be
// escaped first — otherwise a value like `FP4 <script>…</script>` would
// execute when the tooltip renders. We escape values, then still run the
// assembled HTML through DOMPurify as defense-in-depth.
const HTML_ESCAPE = {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'};

function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, ch => HTML_ESCAPE[ch]);
}

function fillTemplate(template, entry) {
  return template.replace(/{{\s*([^}]+)\s*}}/g, (_, key) => escapeHtml(entry[key.trim()]));
}

export default function ChartTooltip(props) {
  const {chartConfig, hoveredDot} = props;

  if (!hoveredDot || !hoveredDot.entry) return null;

  const {title, text} = chartConfig.tooltip;
  const {entry, stroke} = hoveredDot;

  const textParts = text.split('\n');
  const entryText = DOMPurify.sanitize(
    textParts.map(part => `<div>${fillTemplate(part, entry)}</div>`).join('')
  );
  return (
    <div className="nv-chart-tooltip">
      <div className='nv-chart-tooltip__group'>
        <div className='nv-chart-tooltip__label'>{templateReplace(title, entry)}</div>
        <div className='nv-chart-tooltip__content'>
          <div className='nv-chart-tooltip__marker' style={{backgroundColor: stroke}}></div>
          <div className='nv-chart-tooltip__text' dangerouslySetInnerHTML={{__html: entryText}}></div>
        </div>
      </div>
    </div>
  );
}
